import { TextField, Typography } from "./MyCustomFile"
export const MyInput = ({ name, label, value, onChange, error, onBlur, helperText, disabled, status = false }) => {
    return (
        <>
            <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                size="small"
                name={name}
                label={`${label}${status ? "*" : ""}`}
                disabled={disabled || false}
                value={value || ''}
                onChange={onChange}
                error={Boolean(error)}
                onBlur={onBlur}
                helperText={''}
            />
            {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
        </>
    );
}